'use client';

import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import type { ProjectMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { ORDER_TYPE } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/types';
import { MentoringCard } from '../../_components/MentoringCard';
import { ProjectMentoringOptions } from './Options';
export function getDefaultProjectProduct(subscription: Subscription): ProjectMentoringProductDTO {
  return {
    order: ORDER_TYPE.PROJECT_MENTORING,
    subscription,
    email: '',
    name: 'Mentoring projektowy',
    quantity: 1
  };
}
export function ProjectMentoring(t0) {
  const $ = _c(3);
  const {
    goalPage
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProjectMentoringOptions />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== goalPage) {
    t2 = <MentoringCard title="Mentoring projektowy" details={"Dla os\xF3b, kt\xF3rym sama nauka nie wystarcza, kt\xF3re marz\u0105 o zbudowaniu czego\u015B prawdziwego - gotowego produktu, obj\u0119tego pe\u0142nym wsparciem biznesowym oraz mo\u017Cliwo\u015Bci\u0105 zaprezentowania go inwestorom."} variant="premium" goalPage={goalPage}>{t1}</MentoringCard>;
    $[1] = goalPage;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}